import React, { useMemo } from 'react';
import { locale } from '../locale';
import { ConfigContext } from './context';
import { mergeDeep } from './util';
export * from './types';

var ProviderChildren = function ProviderChildren(props) {
  var customLocale = props.locale,
      _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'shopee-react' : _props$prefixCls,
      children = props.children;
  var getPrefixCls = React.useCallback(function (suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? "".concat(prefixCls, "-").concat(suffixCls) : prefixCls;
  }, [prefixCls]);
  var config = useMemo(function () {
    return {
      locale: mergeDeep({}, locale, customLocale),
      getPrefixCls: getPrefixCls
    };
  }, [customLocale, getPrefixCls]);
  return (
    /*#__PURE__*/
    React.createElement(ConfigContext.Provider, {
      value: config
    }, children)
  );
};

var ConfigProvider = function ConfigProvider(props) {
  return (
    /*#__PURE__*/
    React.createElement(ProviderChildren, props)
  );
};
/** @private internal Usage. do not use in your production */


ConfigProvider.ConfigContext = ConfigContext;
export default ConfigProvider;